import * as React from 'react';
import { useState, useEffect } from "react";
import { Field, Form } from 'formik';
import * as Yup from 'yup';
import FormikForm from '~/lib/forms/FormikForm';
import SaleHeader from './SaleHeader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import Button from '~/common/elements/mobile/Button';
import { buttonColor, buttonSize, buttonStyle } from '~/common/elements/mobile/consts';
import Input from '~/common/controls/Input';
import { currency } from '~/lib/formatters';
import { Decimal } from 'decimal.js';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import DatePickerField from "~/common/controls/DatePicker";
import { getCompanyFieldLabel } from "~/apps/pos/helpers";


const saleSchema = (showTimeInputs, hiddenPo) => Yup.object().shape({
  poNumber: !hiddenPo ? Yup.string().required('Required') : undefined,
  company: Yup.string().required('Required'),
  description: Yup.string(),
  ...(showTimeInputs ? {
    arrivalTime: Yup.date().nullable(),
    checkInTime: Yup.date().nullable(),
  } : {}),
});

type Props = {
  initialValues: any,
  total: Decimal,
  onBack: any,
  onHelp: any,
  onClose: any,
  onSubmit: any,
  setFormData: any,
  actionKeyBack: number,
  showTimeInputs: boolean;
  features: string[];
  hasHidePoNumberFeature: boolean;
}

const SaleStepInfo = (props: Props) => {
  const {
    initialValues, onBack, onHelp, onClose, onSubmit, setFormData, total, actionKeyBack, showTimeInputs, features,
    hasHidePoNumberFeature,
  } = props;
  const [isInitialValid, setInitialValid] = useState(false);
  const [isSubmit, setSubmit] = useState(false);

  const handleHelp = onHelp ? () => { onHelp(actionKeyBack) } : null;

  const handleOnSubmit = (data) => {
    setSubmit(true);
    if (setFormData) setFormData(data);
    return onSubmit(saleSchema(showTimeInputs, hasHidePoNumberFeature).cast(data));
  };

  useEffect(() => {
    saleSchema(showTimeInputs, hasHidePoNumberFeature).isValid(initialValues).then(valid => {
      if (valid) setInitialValid(true)
    });
  }, [])

  return (
    <FormikForm
      initialValues={{
        ...initialValues,
        arrivalTime: initialValues.arrivalTime || new Date(),
        checkInTime: initialValues.checkInTime || new Date(),
      }}
      onSubmit={handleOnSubmit}
      validationSchema={saleSchema(showTimeInputs, hasHidePoNumberFeature)}
      isInitialValid={isInitialValid}
      render={(propsForm) => {

        return (
          <PageMobileWrapper>
            <SaleHeader
              onBack={onBack}
              onHelp={handleHelp}
              onClose={onClose}
              title={`$ ${currency(total)}`}
            />

            <BodyWrapper>
              <Form className="form__cont">

                {!hasHidePoNumberFeature &&
                  <Field
                    name="poNumber"
                    label="PO#"
                    type="text"
                    component={Input}
                    className="input input--sm"
                  />
                }
                <Field
                  name="company"
                  label={getCompanyFieldLabel(features)}
                  type="text"
                  component={Input}
                  className="input input--sm"
                />

                {showTimeInputs &&
                  <div className="input--date--row">
                    <Field
                      name="arrivalTime"
                      label="Arrival Time"
                      type="text"
                      className="input input--sm input--date"
                      dateFormat="MMMM d, yyyy h:mm aa"
                      component={DatePickerField}
                      shouldCloseOnSelect={false}
                      showTimeInput
                      withPortal
                      timeInputLabel="Select Time:"
                    />
                    <Field
                      name="checkInTime"
                      label="Check-in Time"
                      type="text"
                      className="input input--sm input--date"
                      dateFormat="MMMM d, yyyy h:mm aa"
                      component={DatePickerField}
                      shouldCloseOnSelect={false}
                      showTimeInput
                      withPortal
                      timeInputLabel="Select Time:"
                    />
                  </div>
                }

                <Field
                  name="description"
                  label="notes"
                  type="text"
                  component={Input}
                  className="input input--sm"
                />

              </Form>
            </BodyWrapper>
            <FooterWrapper>
              <Button
                title={isSubmit ? 'Please Wait...' : propsForm.isValid ? 'Next' : 'Complete fields to continue'}
                buttonStyle={isSubmit ? buttonStyle.SECN : propsForm.isValid ? buttonStyle.OUTL_LITE : buttonStyle.LARY}
                buttonSize={buttonSize.LG}
                buttonColor={propsForm.isValid ? buttonColor.PRIM : null}
                onClick={!isSubmit ? propsForm.submitForm : null}
              />
            </FooterWrapper>
          </PageMobileWrapper>
        );
      }}
    />
  );
};

export default SaleStepInfo;
